import { makeStyles } from "@material-ui/core";
import { blue, grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing, palette }) => ({
  form: {
    padding: 0,
    paddingTop: spacing(3),
    display: "flex",
    flexDirection: "column",
    gap: spacing(3),
    backgroundColor: "transparent",
  },
  infoText: {
    color: grey[500],
    fontWeight: 400,
    lineHeight: 1.2,
  },
  actions: {
    padding: 0,
  },
  leftAction: {
    paddingLeft: spacing(2),
  },
  idealElement: {
    boxSizing: "border-box",
    padding: spacing(0.5, 0.25),
    borderRadius: spacing(0.5),
    border: `1px solid ${palette.separator.main}`,
    width: "100%",
    maxWidth: "100%",
    fontFamily: "Poppins",
    "&:hover": {
      border: "1px solid black",
    },
  },
  focused: {
    border: `2px solid ${blue.A400} !important`,
    margin: "-1px",
  },
}));

export default styles;
